import { useState } from "react";
import { useCurrency } from "@/context/CurrencyContext";
import { ChevronDown, Check } from "lucide-react";

export const CurrencySwitcher = ({ compact = false, className = "" }) => {
  const { code, setCode, all } = useCurrency();
  const [open, setOpen] = useState(false);

  return (
    <div className={`relative ${className}`}>
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label="Change currency"
        data-testid="currency-switcher"
        className={`inline-flex items-center gap-1.5 overline text-forest/80 hover:text-forest transition-colors duration-500 ${
          compact ? "" : "border border-hairline rounded-full px-3 py-1.5"
        }`}
      >
        <span>{code}</span>
        <ChevronDown size={12} strokeWidth={1.6} className={`transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-2 z-50 min-w-[220px] bg-white border-hairline shadow-[0_4px_20px_rgba(0,0,0,0.06)] py-1">
            {Object.values(all).map((c) => {
              const on = c.code === code;
              return (
                <button
                  key={c.code}
                  onClick={() => {
                    setCode(c.code);
                    setOpen(false);
                  }}
                  data-testid={`currency-option-${c.code}`}
                  className={`w-full flex items-center justify-between gap-3 px-4 py-2.5 text-sm ${
                    on ? "bg-beige/40 text-forest" : "text-forest/80 hover:bg-beige/30"
                  }`}
                >
                  <span className="flex items-center gap-2">
                    <span className="font-display text-forest text-base">{c.symbol}</span>
                    <span>{c.code}</span>
                    <span className="text-forest/50 text-xs">· {c.country}</span>
                  </span>
                  {on && <Check size={14} strokeWidth={1.6} className="text-gold" />}
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};
